module.exports = __webpack_public_path__ + "static/media/bolso (17).1643aae6.jpg";